import { render, staticRenderFns } from "./ShelvePopup.vue?vue&type=template&id=498d9691"
import script from "./ShelvePopup.vue?vue&type=script&lang=js"
export * from "./ShelvePopup.vue?vue&type=script&lang=js"
import style0 from "./ShelvePopup.vue?vue&type=style&index=0&id=498d9691&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports